(() => {
  const OVERLAY_CLASS = 'zoom-overlay';
  const ZOOMED_IMG_CLASS = 'zoomed-img';

  function makeOverlay(src, alt) {
    const o = document.createElement('div');
    o.className = OVERLAY_CLASS;
    o.innerHTML = `<img class="${ZOOMED_IMG_CLASS}" src="${src}" alt="${alt || ''}">`;
    const close = () => o.remove();
    o.addEventListener('click', close);
    const escCloser = (e) => { if (e.key === 'Escape') { close(); document.removeEventListener('keydown', escCloser); } };
    document.addEventListener('keydown', escCloser);
    return o;
  }

  function disableCellOverlayLink(imgEl) {
    const mediaCell = imgEl.closest('.cart-item__media');
    if (!mediaCell) return;
    const overlayLink = mediaCell.querySelector('.cart-item__link');
    if (overlayLink) {
      overlayLink.style.pointerEvents = 'none';
      overlayLink.setAttribute('aria-hidden', 'true');
      overlayLink.tabIndex = -1;
    }
  }

  function bindOverlay(img) {
    if (!img || img.__kxOverlayBound) return;
    img.__kxOverlayBound = true;

    disableCellOverlayLink(img);

    // If inside cart drawer, tag to disable hover zoom
    if (img.closest('cart-drawer')) {
      img.classList.add('no-hover-zoom');
    }

    // Click -> lightbox overlay
    img.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      document.body.appendChild(makeOverlay(img.src, img.alt));
    });
  }

  function enhanceAll(scope = document) {
    // Target any personalised thumbs you marked with .enlarge (main cart) or any
    // cart media images that are personalised thumbs (keep .enlarge convention)
    scope.querySelectorAll('.cart-item__media img.enlarge').forEach(bindOverlay);
  }

  // Initial run
  enhanceAll();

  // Re-bind when Dawn refreshes cart sections (main cart or drawer)
  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      m.addedNodes?.forEach((n) => {
        if (!(n instanceof HTMLElement)) return;
        if (
          n.matches?.('cart-drawer, .drawer__inner, #CartDrawer, #CartDrawer-CartItems, #main-cart-items') ||
          n.closest?.('cart-drawer, .drawer__inner, #CartDrawer, #CartDrawer-CartItems, #main-cart-items') ||
          n.querySelector?.('.cart-item__media img.enlarge')
        ) {
          enhanceAll(n);
        }
      });
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
